import { translate } from "@/config/translator";
import { PspSelectProps } from "./pspSelect/pspSelect.types";
import { Select } from "@fluentui/react-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { usePspSelect } from "./pspSelect/usePspSelect";
import { clsx } from "clsx/lite";

export default function PspSelect<
  T extends string | number | boolean | undefined = string,
>({
  children,
  value,
  label,
  onChange,
  disabled,
  labelString,
  appearance,
  size = "large",
}: PspSelectProps<T>) {
  const { lang, onChangeWrapper, selectId } = usePspSelect({ value, onChange });
  return (
    <div
      className={clsx(
        "w-full",
        "flex",
        "flex-col",
        "group",
        size === "small" ? "gap-0" : "gap-2",
      )}
    >
      {/* LABEL */}
      {(label || labelString) && (
        <label
          htmlFor={selectId}
          className={clsx(
            size === "small" && "text-xs",
            "text-font-secondary",
            !disabled && "group-focus-within:text-font-black",
            "duration-200",
            "ease-in-out",
          )}
        >
          {label ? translate(label, lang) : labelString}
        </label>
      )}

      {/* SELECT COMPONENT */}
      <div className="hidden tablet:block">
        <Select
          value={value === undefined ? "" : String(value)}
          onChange={onChangeWrapper}
          appearance={appearance}
          size={size}
          required
          inputMode="search"
          disabled={disabled}
          id={selectId}
        >
          {children}
        </Select>
      </div>
      <div className="relative tablet:hidden">
        <select
          id={selectId}
          content={value as string}
          onChange={onChangeWrapper}
          value={value === undefined ? "" : String(value)}
          className="
            border-b
            appearance-none
            border-b-neutral
            px-4
            py-2
            flex
            flex-row
            justify-between
            w-full
            outline-none
          "
        >
          {children}
        </select>
        <div
          className="
            pointer-events-none
            absolute
            inset-y-0
            right-0
            flex
            items-center
            text-font-secondary
          "
        >
          <FontAwesomeIcon icon={faChevronDown} size="lg" />
        </div>
      </div>
    </div>
  );
}
